<div class="min-h-screen bg-gray-50 flex">
    <!-- Left Side: Image (Hidden on mobile) -->
    <div class="hidden lg:block lg:w-3/5 relative">
        <div class="absolute inset-0 bg-white rounded-br-[50px] rounded-tr-[50px] overflow-hidden z-10 shadow-xl">
            <img src="assets/images/Frame_1000004687.png" alt="Auth Background" class="w-full h-full object-cover" />
        </div>
    </div>

    <!-- Right Side -->
    <div class="w-full lg:w-2/5 flex flex-col">
        <div class="flex-1 flex items-center justify-center p-8 bg-white">
            <div class="w-full max-w-md space-y-8">

                <!-- Logo -->
                <div class="text-center">
                    <img src="assets/images/logometasmile.png" alt="Metasmile Logo"
                        class="h-16 mx-auto mb-6 object-contain" />
                </div>

                <!-- Checking session state -->
                <div *ngIf="isCheckingSession" class="text-center space-y-4 py-8">
                    <i class="pi pi-spin pi-spinner text-3xl text-primary"></i>
                    <p class="text-sm text-slate-500 uppercase tracking-wider font-black text-[10px]">{{ 'reset_verifying_link' | translate }}</p>
                </div>

                <!-- Invalid / expired link -->
                <div *ngIf="!isCheckingSession && !hasValidSession" class="text-center space-y-6 py-8">
                    <div
                        class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rose-50 text-rose-500 mb-4">
                        <i class="pi pi-times text-2xl font-bold"></i>
                    </div>
                    <div class="space-y-2">
                        <h2 class="text-xl font-bold text-slate-800 uppercase tracking-wider">
                            {{ 'reset_link_invalid_title' | translate }}
                        </h2>
                        <p class="text-sm text-slate-500">
                            {{ (invalidReason === 'missing' ? 'reset_link_missing_body'
                                : invalidReason === 'verify_failed' ? 'reset_link_verify_failed'
                                : 'reset_link_invalid_body') | translate }}
                        </p>
                    </div>
                    <div class="pt-4">
                        <app-button [fullWidth]="true" (onClick)="router.navigate(['/forgot-password'])"
                            [label]="'reset_request_new_link' | translate" variant="primary"></app-button>
                    </div>
                </div>

                <!-- Valid session — show reset form -->
                <ng-container *ngIf="!isCheckingSession && hasValidSession">
                    <!-- Header -->
                    <div class="space-y-2">
                        <h2 class="text-xl font-bold text-slate-800 uppercase tracking-wider">
                            {{ 'tk6n1bzi' | translate }}
                        </h2>
                        <p class="text-sm text-slate-500">
                            {{ 'qx6vxjty' | translate }}
                        </p>
                    </div>

                    <!-- Form -->
                    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="mt-8 space-y-6">
                        <div class="space-y-5">
                            <!-- New Password -->
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[10px] font-black text-slate-500 uppercase tracking-[0.15em]">
                                    {{ 'jclhkuoo' | translate }} <span class="text-rose-500">*</span>
                                </label>
                                <p-password formControlName="password" [placeholder]="'tyfq4e8y' | translate"
                                    [toggleMask]="true" [feedback]="false" styleClass="w-full"
                                    inputStyleClass="w-full !rounded-xl !border-slate-200 focus:!border-primary focus:!ring-1 focus:!ring-primary transition-all p-2.5 !text-[13px]"
                                    [class.ng-invalid]="resetForm.get('password')?.touched && resetForm.get('password')?.invalid"
                                    [class.ng-dirty]="resetForm.get('password')?.touched && resetForm.get('password')?.invalid"></p-password>
                                <small *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.invalid"
                                    class="text-rose-500 text-[9px] uppercase tracking-wider font-bold">
                                    {{ 'reset_password_required_min' | translate }}
                                </small>
                            </div>

                            <!-- Confirm Password -->
                            <div class="flex flex-col gap-1.5">
                                <label class="text-[10px] font-black text-slate-500 uppercase tracking-[0.15em]">
                                    {{ '1k8r84no' | translate }} <span class="text-rose-500">*</span>
                                </label>
                                <p-password formControlName="confirmPassword" [placeholder]="'qhwuxecy' | translate"
                                    [toggleMask]="true" [feedback]="false" styleClass="w-full"
                                    inputStyleClass="w-full !rounded-xl !border-slate-200 focus:!border-primary focus:!ring-1 focus:!ring-primary transition-all p-2.5 !text-[13px]"
                                    [class.ng-invalid]="resetForm.get('confirmPassword')?.touched && (resetForm.get('confirmPassword')?.invalid || resetForm.hasError('mismatch'))"
                                    [class.ng-dirty]="resetForm.get('confirmPassword')?.touched && (resetForm.get('confirmPassword')?.invalid || resetForm.hasError('mismatch'))"></p-password>
                                <small
                                    *ngIf="resetForm.get('confirmPassword')?.touched && resetForm.hasError('mismatch')"
                                    class="text-rose-500 text-[9px] uppercase tracking-wider font-bold">
                                    {{ 'passwords_do_not_match' | translate }}
                                </small>
                            </div>
                        </div>

                        <div class="pt-2">
                            <app-button [fullWidth]="true" type="submit" [loading]="isLoading"
                                [disabled]="resetForm.invalid || isLoading" [label]="'z72qub2c' | translate"
                                variant="primary"></app-button>
                        </div>
                    </form>

                    <!-- Back to login -->
                    <div class="mt-8 text-center">
                        <a routerLink="/login"
                            class="text-[8.5px] font-black text-primary hover:text-primary-hover transition-colors uppercase tracking-[0.1em] cursor-pointer inline-flex items-center gap-2">
                            <i class="pi pi-arrow-left text-[8px]"></i>
                            {{ 'xepeph19' | translate }}
                        </a>
                    </div>
                </ng-container>

            </div>
        </div>

        <!-- Footer -->
        <div class="h-16">
            <app-auth-footer />
        </div>
    </div>
</div>